const useSeo = () => {
  const formatSeoData = (data) => {
    const {
      _createdAt: publishedDate,
      _updatedAt: updatedDate,
      seo: seoData
    } = data || {};

    const { title, description, image: ogImage, schema } = seoData || {};

    const seo = {
      title,
      description,
      image: ogImage?.asset?.url && ogImage.asset?.url,
      schema,
      publishedDate,
      updatedDate
    };

    return seo;
  };

  return {
    formatSeoData
  };
};

export default useSeo;
